import { SubscriptionTypeFlags } from '../../../../../../../shared/constants/user-info/subscription';

export const getUpdateCardUnavailableReason = (
  isSubscriptionAvailable: boolean,
  subscriptionTypeFlags: SubscriptionTypeFlags,
): string | null => {
  if (!isSubscriptionAvailable) {
    return 'Card update is not available because customer has no active subscription';
  }
  if (subscriptionTypeFlags.FREE_ACCESS) {
    return 'Card is not available in Free access';
  }
  if (subscriptionTypeFlags.SELF_BILLING) {
    return 'Card is unavailable for Self-Billing Payment';
  }
  return null;
};
